import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FoodI } from '../../../interfaces/foods/foods.interface';
import { UserI } from '../../../interfaces/users/user.interface';
import { FoodsService } from '../../../services/foods.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-user-foods-modal',
  templateUrl: './user-foods-modal.component.html',
  styleUrls: ['./user-foods-modal.component.scss']
})
export class UserFoodsModalComponent implements OnInit {

  @Input() user: UserI;
  @Output() qualificationSubmit = new EventEmitter();
  @Output() closeModal = new EventEmitter();

  @Input() public userFoods: FoodI[];
  public loadingFoods = false;
  sendingFood = false;
  @Input() needSelfLoadFoods: boolean;

  constructor(
    private messageService: MessageService,
    private foodServ: FoodsService,
  ) {
  }

  ngOnInit(): void {
    if (this.needSelfLoadFoods == true) {
      this.loadFoodUsr();
    }
  }

  loadFoodUsr() {
    this.loadingFoods = true;

    this.foodServ.getUserFoods(this.user.id).subscribe(res => {
      if (res.ok === true) {

        let _userFoods: FoodI[] = res.foods;

        this.userFoods = _userFoods.sort((a, b) => b.id - a.id);

      }
      this.loadingFoods = false;
    }, error => {
      this.loadingFoods = false;
      console.log(error);
    });
  }

  emitQualification(event) {
    this.qualificationSubmit.emit(event);
  }

  onClose() {
    this.closeModal.emit();
  }

}
